/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1769
 */

"use strict"

var r = require(/* 257 */"./1754/257/index")
var /* [auto-meaningful-name] */require_950_$_1768_950$right = require(/* 950 */"./1768/950").right
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("reduceRight", function (e) {
  return require_950_$_1768_950$right(r$aTypedArray(this), e, arguments.length, arguments.length > 1 ? arguments[1] : undefined)
})
